<template>
	<div class="modal-reset-tuto-confirmation">
		<div class="bg" v-tap="close"></div>
		<div class="content">

			<div class="title">{{ $t('modalResetTuto.title') }}</div>
			<div class="description">{{ $t('modalResetTuto.description') }}</div>
			<div class="question">{{ $t('modalResetTuto.question') }}</div>

			<div class="buttons">
				<ui-button size="big" color="dark-green" v-tap="close">{{ $t('modalResetTuto.buttonCancel') }}</ui-button>
				<ui-button size="big" color="red" :loading="loading" v-tap="submit">{{ $t('modalResetTuto.buttonSubmit') }}</ui-button>
			</div>

		</div>
	</div>
</template>

<script>
import { mapActions } from 'pinia'
import { useOnboardingStore } from '@/store/onboarding'
import UiButton from '@/components/ui/ui-button.vue'

export default {
	name: 'modal-reset-tuto-confirmation',
	data() {
		return {
			loading: false
		}
	},
	methods: {
		...mapActions(useOnboardingStore, [ 'resetAllTutos' ]),
		close() {
			this.$emit('close')
		},
		async submit() {
			if (!this.loading) {
				this.loading = true
				await this.resetAllTutos()
				location.href = '/'
			}
		},
	},
	components: { UiButton },
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

#app > .low-perf
	.modal-reset-tuto-confirmation
		transition none
		.bg, .content
			transition none

#mobile
	.modal-reset-tuto-confirmation
		.content
			.buttons
				flex-direction column
				row-gap 16px
				.ui-button
					width 100%

.modal-reset-tuto-confirmation
	absolute 0
	flex center center
	height 100%
	padding 80px 16px
	transition 0.2s easeOutQuart
	z-index 20
	&.modal-enter-from, &.modal-leave-to
		.bg
			opacity 0
		.content
			transform translateY(-16px)
			opacity 0
	.bg
		absolute 0
		background-color alpha(#000, 50%)
		transition 0.2s easeOutQuart
	.content
		width 100%
		max-width 600px
		padding 32px
		border-radius 8px
		background-color #fff
		text-align center
		transition 0.2s easeOutQuart
		.title
			width 100%
			margin 0 0 16px 0
			text-transform uppercase
			font-size 2.4rem
			color #446E6E
		.description
			width 100%
			margin 0 0 8px 0
		.question
			width 100%
			margin 0 0 32px 0
			font-weight 500
		.buttons
			flex center center
			gap 32px
			.ui-button
				width 50%
				height auto
				min-height 48px
				padding-top 8px
				padding-bottom 8px
				line-height 1.2em

</style>
